module.exports = __webpack_public_path__ + "static/media/fly0186.1e2e715c.webp";